import React from "react";
import * as icons from "react-bootstrap-icons";
import HomePageBtn from "./components/HomePageBtn";
import { useTranslation } from "react-i18next";

export default function OnFirstButtonsIndex({ externalData }) {
  const { t } = useTranslation();
  return (
    <>
      {(externalData.number_of_projects === 0 ||
        externalData.number_of_customers === 0) && (
        <div className="HomeButton mt-3">
          <HomePageBtn
            icon={<icons.PersonAdd />}
            title={t("customer_registration")}
            description={t("customer_registration_exp")}
            btnText={t("customer_registration_section")}
            route={"/dashboard/customers"}
          />
          <HomePageBtn
            icon={<icons.Layers />}
            title={t("customer_project")}
            description={t("customer_project_exp")}
            btnText={t("customer_project_section")}
            route={"/dashboard/projects/list"}
          />
        </div>
      )}
    </>
  );
}
